// The user's layout preferences object in localStorage (spec 6.1.9, 6.8.8): `theme` and `dock` members.

/** Per-user layout preferences: the theme and the tool-window layout. */
export function layoutKey(user: string): string {
  return `nebisys.layout.v1:${user}`;
}

/** localStorage, or null when the browser blocks it. */
export function storage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

/** The user's layout object; empty when missing, unparsable or not an object. Never throws. */
export function readLayoutObject(user: string, store: Storage | null = storage()): Record<string, unknown> {
  if (!store) return {};
  try {
    const parsed: unknown = JSON.parse(store.getItem(layoutKey(user)) ?? 'null');
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)
      ? (parsed as Record<string, unknown>)
      : {};
  } catch {
    return {};
  }
}

/** Sets one member of the user's layout object, keeping the others. Storage errors are ignored. */
export function writeLayoutMember(
  user: string,
  member: string,
  value: unknown,
  store: Storage | null = storage(),
) {
  if (!store) return;
  try {
    store.setItem(layoutKey(user), JSON.stringify({ ...readLayoutObject(user, store), [member]: value }));
  } catch {
    // Quota or privacy settings: the change lasts for this page only.
  }
}
